import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {ApiV2Service} from './api-v2.service';
@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router,private apiService:ApiV2Service) {
        //console.log("AuthGuard")
     }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        try {
            if (localStorage.getItem('reauth_required') || sessionStorage.getItem('reauth_required')) {
                this.apiService.invalidateSessionState();
                this.router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
                return false;
            }
        } catch {
            /* ignore */
        }

        const currentUser = this.apiService.currentUserValue;
        if (currentUser) {
            return true;
        }

        const emailActive = localStorage.getItem('active_account');
        const accounts = JSON.parse(localStorage.getItem('accounts') || '[]');
        const activeAccount = accounts.find((acc: any) => acc.email === emailActive);
        const hasRefreshToken =
            !!localStorage.getItem('refresh_token') || !!activeAccount?.refresh_token;

        if (hasRefreshToken) {
            const restored = await this.apiService.getSetCurrentUser();
            if (restored) {
                return true;
            }
        }
        console.log("AuthGuard",currentUser,false);

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/auth'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}